class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (!this.desktopMediaQuery.matches) return;
    for (const sibling of this.parentElement.querySelectorAll('header-menu')) {
      if (sibling !== this) sibling.closeImmediate();
    }
    this.open();
  }

  onMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;
    this.closeAnimated();
  }

  open() {
    if (this.closingAnimation) {
      this.closingAnimation.cancel();
      this.closingAnimation = null;
    }

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);

    for (const anim of this.content.getAnimations()) {
      anim.cancel();
    }

    if (this.desktopMediaQuery.matches) {
      this.content.animate(
        [
          { opacity: 0, transform: 'translateY(-2.5rem)' },
          { opacity: 1, transform: 'translateY(0)' },
        ],
        { duration: 120, easing: 'ease-out', fill: 'forwards' }
      );
    }
  }

  closeAnimated() {
    if (!this.mainDetailsToggle.open) return;

    const keyframes = [
      { opacity: 1, transform: 'translateY(0)' },
      { opacity: 0, transform: 'translateY(-1rem)' },
    ];

    this.closingAnimation = this.content.animate(keyframes, {
      duration: 80,
      easing: 'ease-in',
    });

    this.closingAnimation.onfinish = () => {
      this.closingAnimation = null;
      this.close();
    };
  }

  closeImmediate() {
    if (this.closingAnimation) {
      this.closingAnimation.cancel();
      this.closingAnimation = null;
    }
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
